webpackJsonp([9],{

/***/ 4011:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(3956);
	
	var _ManageDataSource = __webpack_require__(4012);
	
	var _ManageDataSource2 = _interopRequireDefault(_ManageDataSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ManageDataSource2.default);

/***/ },

/***/ 4012:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	var _antd = __webpack_require__(781);
	
	var _GeneralInformation = __webpack_require__(4013);
	
	var _GeneralInformation2 = _interopRequireDefault(_GeneralInformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Content = _antd.Layout.Content,
	    Footer = _antd.Layout.Footer;
	
	var Step = _antd.Steps.Step;
	
	var steps = [{
	  title: 'General Information',
	  content: _react2.default.createElement(_GeneralInformation2.default, null)
	}, {
	  title: 'Second',
	  content: 'Second-content'
	}, {
	  title: 'Last',
	  content: 'Last-content'
	}];
	
	var ManageDataSource = function (_Component) {
	  (0, _inherits3.default)(ManageDataSource, _Component);
	
	  function ManageDataSource(props) {
	    (0, _classCallCheck3.default)(this, ManageDataSource);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ManageDataSource.__proto__ || (0, _getPrototypeOf2.default)(ManageDataSource)).call(this, props));
	
	    _this.state = {
	      current: 0
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ManageDataSource, [{
	    key: 'next',
	    value: function next() {
	      var current = this.state.current + 1;
	      this.setState({ current: current });
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      var current = this.state.current - 1;
	      this.setState({ current: current });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var current = this.state.current;
	
	      return _react2.default.createElement(
	        _antd.Layout,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'manageDataSource.title', defaultMessage: 'Create Data Source' })
	        ),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _antd.Steps,
	              { current: current },
	              steps.map(function (item) {
	                return _react2.default.createElement(Step, { key: item.title, title: item.title });
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'steps-content' },
	              steps[this.state.current].content
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'steps-action' },
	              this.state.current < steps.length - 1 && _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: function onClick() {
	                    return _this2.next();
	                  } },
	                'Next'
	              ),
	              this.state.current === steps.length - 1 && _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: function onClick() {
	                    return message.success('Processing complete!');
	                  } },
	                'Done'
	              ),
	              this.state.current > 0 && _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: function onClick() {
	                    return _this2.prev();
	                  } },
	                'Previous'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(Footer, { style: { textAlign: 'center' } })
	      );
	    }
	  }]);
	  return ManageDataSource;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(ManageDataSource);

/***/ },

/***/ 4013:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(1316);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(794);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(795);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(796);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(814);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(301);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(2594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GeneralInformation = function (_Component) {
	  (0, _inherits3.default)(GeneralInformation, _Component);
	
	  function GeneralInformation() {
	    (0, _classCallCheck3.default)(this, GeneralInformation);
	    return (0, _possibleConstructorReturn3.default)(this, (GeneralInformation.__proto__ || (0, _getPrototypeOf2.default)(GeneralInformation)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GeneralInformation, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Hello there'
	      );
	    }
	  }]);
	  return GeneralInformation;
	}(_react.Component);
	
	exports.default = (0, _reactIntl.injectIntl)(GeneralInformation);

/***/ }

});


// WEBPACK FOOTER //
// 9.webpack_build.js